<template>
    <div class="box box-primary">
        <div class="box-header with-border">
            <h3 class="box-title">Filter</h3>
            <div class="box-tools pull-right">
                <button
                    class="btn btn-box-tool"
                    title="Collapse"
                    type="button"
                    @click="toggleCollapse"
                >
                    <i
                        :class="changeIcon(collapse)"
                        class="fa"
                    ></i>
                </button>
            </div>
        </div>

        <vue-slide-up-down
            :active="collapse"
            :duration="durationCollapse"
        >
            <div class="box-body">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <form
                            action=""
                            method="get"
                            role="form"
                            @submit.prevent="newQueryURL"
                        >
                            <div class="row">
                                <DateRangeComponentVue
                                    id="filter_dates"
                                    :disabled="enableFilter.disableWrapper"
                                    :end="endDate"
                                    :start="startDate"
                                    class-input="form-control"
                                    class-main-block="form-group col-xs-12 col-sm-3 col-lg-3"
                                    placeholder="Dates Range"
                                    title="Dates"
                                    @change="changeDate"
                                />
                                <div class="form-group col-lg-3 col-md-4 col-xs-12">
                                    <label>{{ $t('name') }}</label>
                                    <input
                                        v-model="search"
                                        :placeholder="`${$t('enter')} ${$t('name')}`"
                                        class="form-control"
                                        type="text"
                                    />
                                </div>
                                <div
                                    :class="enableFilter.disableWrapper"
                                    class="form-group col-xs-12 col-sm-3 col-lg-3"
                                    @click="preventEnter"
                                    @keydown="preventEnter"
                                >
                                    <label class="col-xs-12 hidden-xs">&nbsp;</label>
                                    <button
                                        :class="enableFilter.disableBtn"
                                        :disabled="disabled"
                                        class="btn btn-sm btn-primary"
                                        type="submit"
                                    >
                                        Apply
                                    </button>
                                    <a
                                        :class="[enableFilter.disableBtn, { disabled: disabled }]"
                                        :href="getPath()"
                                        class="btn btn-sm btn-info"
                                        @click.prevent="clearFilter"
                                    >
                                        Clear
                                    </a>
                                </div>
                            </div>
                        </form>
                        <div
                            v-if="filterErrors"
                            class="form-group has-error"
                        >
                            <span
                                class="help-block"
                                v-text="filterErrors"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </vue-slide-up-down>
    </div>
</template>

<script>
import DateRangeMixin from '../../mixins/date-range-mixin';
import DateRangeComponentVue from '@/components/partials/DateRangeComponentVue';

export default {
    name: 'CategoriesFilter',
    components: {
        DateRangeComponentVue,
    },
    mixins: [DateRangeMixin],
    props: {
        enableFilter: {
            type: Object,
            default: () => ({}),
        },
        defaultRange: {
            type: String,
            default: '',
        },
        filterErrors: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            search: '',
            startDate: this.formatDate(new Date()),
            endDate: this.formatDate(new Date()),
            collapse: false,
            durationCollapse: 700,
        };
    },
    mounted() {
        const hasSearch = this.$route.query['filter[search]'];
        const hasDates = this.$route.query['filter[dates]'];

        if (hasSearch) {
            this.search = hasSearch;
            this.collapse = true;
        }

        if (hasDates) {
            this.queryProcess();
            this.collapse = true;
        } else if (this.defaultRange) {
            this.setDefaultRange();
            this.collapse = true;
        }
    },
    methods: {
        setDefaultRange() {
            let [startDate, endDate] = this.getDefaultRangeDates();
            this.startDate = this.formatDate(startDate);
            this.endDate = this.formatDate(endDate);
        },
        preventEnter(event) {
            if (this.enableFilter.preventEnterFilter) {
                return event.preventDefault();
            }
        },
        queryProcess() {
            let values = this.$route.query['filter[dates]'];
            let dateRegexp = /\d{4}-\d{2}-\d{2}\s-\s\d{4}-\d{2}-\d{2}/;
            if (dateRegexp.test(values)) {
                let dates = values.split(' - ');
                this.startDate = dates[0];
                this.endDate = dates[1];
            }
        },
        formatDate(value) {
            if (value) {
                return window.moment(value.toISOString()).format('YYYY-MM-DD');
            }
        },
        newQueryURL() {
            let query = { page: '1' };

            if (this.search) {
                query['filter[search]'] = this.search;
            }

            query['filter[dates]'] = window.moment(this.startDate).format('YYYY-MM-DD') +
                ' - ' +
                window.moment(this.endDate).format('YYYY-MM-DD');

            this.$router.push({
                path: this.getPath(),
                query,
            }).catch(() => {});
        },
        clearFilter() {
            if (this.disabled) {
                return;
            }

            this.search = '';
            this.setDefaultRange();
            this.$router.push({ path: this.getPath() }).catch(() => {});
        },
        getPath() {
            return this.$route.path;
        },
        changeIcon(value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
        changeDate(value) {
            let dates = value.split(' - ');
            this.startDate = dates[0];
            this.endDate = dates[1];
        },
    },
};
</script>
